module.exports = __webpack_public_path__ + "static/media/ic_star.9d2cfb94.svg";